import englishTexts from '../core/lang/englishTexts.json'
import portugueseTexts from '../core/lang/portugueseTexts.json'
import { RootState } from '../redux/store'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { setLanguage } from '../redux/slices/languageSlice'

export interface Texts {
	game_not_found: string
	opt_in: string
	play: string
	multiplier: string
	bet: string
	bets: string
	wagered: string
	current_balance: string
	wins: string
	new_tournament: string
	loginButtonFB: string
	loginButtonGoogle: string
	tc_text: string
	tc_link: string
	tc_modal_title: string
	tc_modal_text: string
	tc_modal_button: string
	deposit: string
	withdraw: string
	logOut: string
	profile: string
	statistics: string
	balance: string
	bonus_balance: string
	loyalty_points: string
	vip_free_spins: string
	vip_free_spins_text: string
	sports_weekly_bonus: string
	sports_weekly_bonus_text: string
	luxury_gifts: string
	luxury_gifts_text: string
	exclusive_games: string
	exclusive_games_text: string
	prize: string
	registered: string
	buy_in: string
	leaderboard: string
	more_info: string
	no_tournaments_loaded: string
	rank: string
	player: string
	score: string
	no_players_registered: string
	related_games: string
	days_short: string
	hours_short: string
	minutes_short: string
	seconds_short: string
	join_free: string
	level_up_bonus: string
	recharge_bonus: string
	weekly_cashback: string
	no_fee_withdrawals: string
	private_events: string
	luxury_gifts_experiences: string
	vip_free_spins_benefits: string
	sports_weekly_bonus_benefits: string
	exclusive_game_benefits: string
	mini_games: string
	tournaments: string
	missions: string
	casino: string
	favorite_games: string
	jackpots: string
	gaminfication_links: string
	top_games: string
	tournaments_section: string
	slots_games: string
	new_games: string
	instant_games: string
	original_games: string
	bonus_games: string
	jackpot_games: string
	drop_and_win_games: string
	sports_betting: string
	lottery: string
	settings: string
	loyalty_title: string
	loyalty_subtitle: string
	my_collectibles_title: string
	my_collectibles_subtitle: string
	coming_soon: string
	back: string
	all_games: string
	quiz_dp_title: string
	quiz_dp_desc: string
	levels_dp_title: string
	levels_dp_desc: string
	torunaments_dp_title: string
	mini_games_dp_title: string
	matchx_dp_title: string
	store_dp_title: string
	lobby: string
	sports_betting_info: string
	home: string
	away: string
	draw: string
	loss: string
	win: string
	reset_progress: string
	gathering: string
	started: string
	cancelled: string
	finished: string
	locked: string
	completed: string
	in_progress: string
	requires_optin: string
	attempts: string
	cost: string
	free: string
	join_tournament: string
	auto_optin: string
}

export const useTranslation = (
	includeChangeLanguage: boolean,
): {
	getTexts: (key: keyof Texts) => string
	handleChangeLanguage?: (eventOrCode: React.ChangeEvent<HTMLSelectElement> | string) => void
	selectedLanguage?: string
} => {
	const selectedLanguage = useAppSelector((state: RootState) => state.language.selectedLanguage)
	const dispatch = useAppDispatch()

	const getTexts = (key: keyof Texts) => {
		return selectedLanguage === 'en' ? englishTexts[key] : portugueseTexts[key]
	}

	const handleChangeLanguage = (eventOrCode: React.ChangeEvent<HTMLSelectElement> | string) => {
		const languageCode = typeof eventOrCode === 'string' ? eventOrCode : eventOrCode.target.value

		dispatch(setLanguage(languageCode))
		;(window as any)._smartico.changeLanguage(languageCode)
	}

	if (includeChangeLanguage === true) {
		return { getTexts, handleChangeLanguage, selectedLanguage }
	}

	return { getTexts, selectedLanguage }
}
